import React, { useState } from 'react';
import { Layout as AntLayout, Menu, Button, theme } from 'antd';
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  DashboardOutlined,
  ShoppingOutlined,
  RiseOutlined,
  FileTextOutlined,
  TagsOutlined,
  ApiOutlined,
  DatabaseOutlined,
  BarcodeOutlined,
} from '@ant-design/icons';
import { Link, Outlet, useLocation, Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const { Header, Sider, Content } = AntLayout;

const Layout = () => {
  const [collapsed, setCollapsed] = useState(false);
  const { isAuthenticated } = useAuth();
  const location = useLocation();
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  const menuItems = [
    {
      key: '/',
      icon: <DashboardOutlined />,
      label: <Link to="/">仪表盘</Link>,
    },
    {
      key: '/data-processing',
      icon: <DatabaseOutlined />,
      label: <Link to="/data-processing">数据处理</Link>,
    },
         {
      key: '/inventory-amount',
      icon: <DatabaseOutlined />,
      label: <Link to="/inventory-amount">库存金额处理（新）</Link>,
    },
    {
      key: '/inventory-amount-legacy',
      icon: <DatabaseOutlined />,
      label: <Link to="/inventory-amount-legacy">库存金额处理（旧）</Link>,
    },
    {
      key: '/ean-config',
      icon: <BarcodeOutlined />,
      label: <Link to="/ean-config">EAN配置管理</Link>,
    },
    {
      key: '/sku-config',
      icon: <TagsOutlined />,
      label: <Link to="/sku-config">F-SKU配置管理</Link>,
    },

    {
      key: '/traffic-pool',
      icon: <RiseOutlined />,
      label: <Link to="/traffic-pool">流量池管理</Link>,
    },
    // 以下业务页面已迁移到“后台管理”，在用户侧隐藏
    // {
    //   key: '/product-info',
    //   icon: <FileTextOutlined />,
    //   label: <Link to="/product-info">商品信息生成</Link>,
    // },
    // {
    //   key: '/title-processing',
    //   icon: <FileTextOutlined />,
    //   label: <Link to="/title-processing">标题处理工具</Link>,
    // },
    // {
    //   key: '/data-template',
    //   icon: <FileTextOutlined />,
    //   label: <Link to="/data-template">数据组织与模板</Link>,
    // },
    // {
    //   key: '/product-type',
    //   icon: <TagsOutlined />,
    //   label: <Link to="/product-type">商品类型管理</Link>,
    // },
    // {
    //   key: '/ai-providers',
    //   icon: <ApiOutlined />,
    //   label: <Link to="/ai-providers">AI提供商管理</Link>,
    // },
    // {
    //   key: '/ai-prompts',
    //   icon: <FileTextOutlined />,
    //   label: <Link to="/ai-prompts">AI提示词</Link>,
    // },
  ];

  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  return (
    <AntLayout style={{ minHeight: '100vh' }}>
      <Sider 
        trigger={null} 
        collapsible 
        collapsed={collapsed}
        theme="dark"
        style={{
          boxShadow: '2px 0 8px rgba(0, 0, 0, 0.15)',
          position: 'fixed',
          height: '100vh',
          zIndex: 1000,
        }}
      >
        <div className="p-4 text-white text-center">
          <div className="flex items-center justify-center">
            <img 
              src="/assets/hm.png" 
              alt="山西鸿茂贸易有限公司" 
              className={`transition-all duration-300 ${collapsed ? 'w-10 h-10' : 'w-16 h-16'}`}
              style={{ filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.3))' }}
            />
          </div>
        </div>
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={[location.pathname]}
          items={menuItems}
        />
      </Sider>
      <AntLayout style={{ marginLeft: collapsed ? 80 : 200, transition: 'all 0.2s' }}>
        <Header
          style={{
            padding: '0 24px',
            background: 'linear-gradient(90deg, #1890ff 0%, #36cfc9 100%)',
            position: 'sticky',
            top: 0,
            zIndex: 999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
          }}
        >
          <div className="flex items-center">
            <Button
              type="text"
              icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
              onClick={() => setCollapsed(!collapsed)}
              style={{
                fontSize: '16px',
                width: 64,
                height: 64,
                color: 'white',
                marginRight: '16px',
              }}
            />
            <div className="text-white">
              <div className="text-xl font-bold">
                山西鸿茂贸易有限公司
              </div>
              <div className="text-sm opacity-90">
                亚马逊一站式AI服务ERP
              </div>
            </div>
          </div>
          <div className="flex items-center text-white">
            <div className="text-right">
              <div className="text-lg font-medium">
                {menuItems.find(item => item.key === location.pathname)?.label.props.children}
              </div>
              <div className="text-xs opacity-80">
                当前页面
              </div>
            </div>
          </div>
        </Header>
        <Content
          style={{
            margin: '24px 16px',
            padding: 24,
            background: colorBgContainer,
            borderRadius: borderRadiusLG,
            minHeight: 280,
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
          }}
        >
          <Outlet />
        </Content>
      </AntLayout>
    </AntLayout>
  );
};

export default Layout; 